import { create } from 'zustand';

import { api } from 'src/utils/axios';

import { MyLevelRepository } from 'src/repositories/user/my-level.repository';

import { levelsItemType, myLevelInfoItemType } from 'src/types/user/myLevel';

type States = {
  isLoadingMyLevelInfo: boolean;
  isLoadingNextLevelBenefits: boolean;
  myLevelInfo: myLevelInfoItemType | null;
  nextLevelBenefits: any | null;
};

type Actions = {
  getMyLevelInfo: () => Promise<void>
  getNextLevelBenefits: () => Promise<void>
};

type MyLevel = Actions & States;

const initialValues = {
  isLoadingMyLevelInfo: false,
  isLoadingNextLevelBenefits: false,
  myLevelInfo: null,
  nextLevelBenefits: [],
};

const myLevelRepository = new MyLevelRepository(api)

export const useMyLevelStore = create<MyLevel>((set: any, get: any) => ({
  ...initialValues,

  getMyLevelInfo: async () => {
    set({ isLoadingMyLevelInfo: true });
    const response = await myLevelRepository.getMyLevelInfo();

    if (response.isLeft()) {
      set({ isLoadingMyLevelInfo: false });
      throw new Error(response.value.message);
    } else {
      const translatedLevels = response.value.levels.map((level: levelsItemType) => {
        let translatedName = level.name;

        switch (level.name) {
          case 'silver':
            translatedName = 'Prata';
            break;
          case 'gold':
            translatedName = 'Ouro';
            break;
          case 'diamond':
            translatedName = 'Diamante';
            break;
          default:
            break;
        }

        return { ...level, name: translatedName };
      });

      set({ myLevelInfo: { ...response.value, levels: translatedLevels }, isLoadingMyLevelInfo: false });
    }
  },

  getNextLevelBenefits: async () => {
    set({ isLoadingNextLevelBenefits: true });

    try {
      const response = await myLevelRepository.getNextLevelBenefits();

      if (response.isLeft()) {
        throw new Error(response.value.message);
      }

      set({ nextLevelBenefits: response.value });
    } finally {
      set({ isLoadingNextLevelBenefits: false });
    }
  },

}));
